import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FieldVS } from 'shared/utils/validation/AuthValidation';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { AddCompetibleBrandMutation, UpdateCompetibleBrandMutation } from 'shared/services/competible_brand_service/CompetibleBrandService';
import { toastMessage } from 'shared/components/toast/Toast';

export default function AddCompetibleBrand({ show, datacpmpatible, handleClose, isEdit = false, editData = null, onSuccessAdd }) {
    const { mutate: addCompetibleBrandMutate, isLoading: BrandLoading, isSuccess: BrandIsSuccess } = AddCompetibleBrandMutation();
    const { mutate: updateCompetibleBrandMutate, isLoading: UpdateBrandLoading, isSuccess: UpdateBrandIsSuccess } = UpdateCompetibleBrandMutation();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const initialValues = {
        field: isEdit && editData?.name ? editData.name : ''
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: FieldVS,
        onSubmit: (value) => {
            brandHandler(value);
        }
    });
    const { handleChange, handleSubmit, values, touched, errors } = formik;

    const brandHandler = (values) => {
        const isDuplicate = datacpmpatible?.some(
            (brand) => brand._id !== editData?._id && brand.name.trim().toLowerCase() === values.field.trim().toLowerCase()
        );

        if (isDuplicate) {
            toastMessage('error', `Compatible Brand "${values.field}" already exists!`);
            return;
        }

        if (isEdit && editData?._id) {
            updateCompetibleBrandMutate({ id: editData._id, payload: { name: values.field } });
        } else {
            addCompetibleBrandMutate({ name: values.field });
        }
    };

    useEffect(() => {
        if ((BrandIsSuccess || UpdateBrandIsSuccess) && show) {
            if (onSuccessAdd) onSuccessAdd(values.field);
            formik.resetForm();
            handleClose();
        }
    }, [BrandIsSuccess, UpdateBrandIsSuccess]);

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={isEdit ? 'Edit Compatible Brand' : 'Add Compatible Brand'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomInput
                        label={isEdit ? 'Edit Compatible Brand Name' : 'Add Compatible Brand'}
                        placeholder={'e.g. Samsung'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values.field}
                        onChange={handleChange('field')}
                        error={errors.field && touched.field ? errors.field : ''}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();  // Prevent form refresh
                                handleSubmit();      // Trigger form submit
                            }
                        }}
                    />

                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={isEdit ? 'Update' : 'Add'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
                {(BrandLoading || UpdateBrandLoading) && <OverlayLoading />}
            </Modal.Body>
        </Modal>
    );
}
